import type { ReactNode } from 'react';
import { useAuth } from '@/contexts/AuthContext';
export default function PermissionGate({
  permission,
  children,
}: {
  permission: string;
  children: ReactNode;
}) {
  const { can } = useAuth();
  return can(permission) ? <>{children}</> : null;
}
